/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_CopiedInputs */

const en_mobile_dev_copied = /** @type {(inputs: Mobile_Dev_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard`)
};

const es_mobile_dev_copied = /** @type {(inputs: Mobile_Dev_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado al portapapeles`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Mobile_Dev_CopiedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_copied = /** @type {((inputs?: Mobile_Dev_CopiedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_CopiedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_copied(inputs)
	return en_mobile_dev_copied(inputs)
});